import tw from 'twin.macro'

export const Wrapper = tw.div`flex gap-[2px]`
